export enum ErrorCode {
    REQUIRED_NOT_SELECTED = 'REQUIRED_NOT_SELECTED',
    REQUIRED_MORE_SLOTS = 'REQUIRED_MORE_SLOTS',
    MISMATCH_COUNT = 'MISMATCH_COUNT',
    IMAGE_GENERATION_ISSUE = 'IMAGE_GENERATION_ISSUE',
}

export interface Error {
    uid: string
    code: ErrorCode
}
